import styled from "@emotion/styled";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import { StyledAnimatedSkeleton } from "shared/components/ModuleSkeleton/components/ModuleHeaderSkeleton/styled";
import { COLOR_BLACK_10, COLOR_GREY_8 } from "shared/theme/colors";

interface SkeletonProps {
  width: string;
  height: string;
  marginLeft?: string;
}

export const SkeletonCard = styled(StyledAnimatedSkeleton)<SkeletonProps>`
  height: ${({ height }) => height};
  width: ${({ width }) => width};
  margin-bottom: 15px;
`;

export const EmptyImage = styled("div")<SkeletonProps>`
  height: ${({ height }) => height};
  width: ${({ width }) => width};
  border-radius: 10px;
  background-color: ${COLOR_BLACK_10};
  color: ${COLOR_GREY_8};
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
`;

export const SkeletonGameName = styled(StyledAnimatedSkeleton)`
  width: 77px;
  height: 13px;
`;

export const SkeletonStudio = styled(StyledAnimatedSkeleton)`
  width: 46px;
  height: 8px;
`;

export const SkeletonGameWrapper = styled(FlexColumn)`
  align-items: flex-start;
  gap: 6px;
`;

export const SkeletonCardWrapper = styled(FlexColumn)<{ marginLeft?: string }>`
  align-items: flex-start;
  margin-left: ${({ marginLeft }) => marginLeft || "0"};
  z-index: 1;
`;
